<template>
  <!-- R2 未登录状态简单跳板页、中间页 页头（如：查询管理员账号、获取员工账号页面）  author: zhangxiaofeng-->
  <div class="board-header">
    <logo class="logo-instance"></logo>
    <span class="page-title">
      {{pageTitle}}
    </span>
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .board-header{
    width: 568px;
    height: 72px;
    margin: 0 auto;
    position: relative;
    color: #fff;
    .logo-instance{
      float: left;
      margin-top: 15px;
    }
    .page-title{
      float: right;
      display: inline-block;
      font-size:16px;
      font-weight:400;
      line-height: 72px;
    }
  }
</style>
<script>
import Logo from '_c/Logo.vue'
export default {
  name: 'HeaderBoard',
  components: {
    Logo
  },
  props: {
    pageTitle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  }
}
</script>
